import { getCurrentDubaiDate } from "./getCurrentDubaiDate"

export function getCurrentDubaiDateString (): string {
    const dubaiDate = getCurrentDubaiDate()
    const year = dubaiDate.getFullYear()
    const month = dubaiDate.getMonth() + 1
    const day = dubaiDate.getDate()
    return String(year) + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0')
}
